export class RelationNote {
  constructor(
    public readonly id: string,
    public readonly relationId: string,
    public readonly userId: string,
    public readonly note: string,
    public readonly createdAt: Date,
    public readonly updatedAt: Date
  ) {
  }

  static fromJson(json: any): RelationNote {
    return new RelationNote(
      json['id'],
      json['relation_id'],
      json['user_id'],
      json['note'],
      new Date(json['created_at']),
      new Date(json['updated_at']),
    );
  }
}